import script from "./SwitchLocaltionDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SwitchLocaltionDialog.vue?vue&type=script&lang=ts&setup=true"

import "./SwitchLocaltionDialog.vue?vue&type=style&index=0&id=1601b544&lang=scss"

const __exports__ = script;

export default __exports__